import { render, staticRenderFns } from "./TabelaModalArea.vue?vue&type=template&id=bc0b9b36"
import script from "./TabelaModalArea.vue?vue&type=script&lang=js"
export * from "./TabelaModalArea.vue?vue&type=script&lang=js"
import style0 from "./TabelaModalArea.vue?vue&type=style&index=0&id=bc0b9b36&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports